import { ContentCacheObject, ContentPackageType } from '@csp/csp-common-content-delivery-client';
import { CacheProvider, LocalStorageCacheProviderFactory } from '@csp/web-common';

const DEFAULT_LOCAL_STORAGE_CACHE_KEY = 'unify-content-cache';

export const WebContentCacheProviderFactory = (): CacheProvider<ContentPackageType, ContentCacheObject> =>
  LocalStorageCacheProviderFactory<ContentPackageType, ContentCacheObject>(DEFAULT_LOCAL_STORAGE_CACHE_KEY);
